import React from "react";
import { motion } from "framer-motion";
import { ChevronRight, MessageCircle } from "lucide-react";
import { trackEvent } from "../../utils/gtag";
import { buildCarServiceWhatsAppHref } from "./whatsappConfig";
import { useCarServiceCity } from "./CarServiceCityContext";

/**
 * Sticky bottom-bar CTA visible on mobile only (< lg breakpoint).
 * Routes directly to WhatsApp — the lowest-friction path for paid traffic.
 */
const CarServiceMobileStickyCTA = ({ visible = true }) => {
  const { selectedCity } = useCarServiceCity();
  const whatsappHref = buildCarServiceWhatsAppHref({ city: selectedCity, clickType: "sticky" });
  if (!visible) return null;
  return (
    <motion.div
      initial={{ y: 60 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.4, delay: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/92 backdrop-blur-xl border-t border-slate-200 shadow-[0_-4px_16px_-4px_rgba(15,23,42,0.08)] p-3"
      data-testid="mobile-sticky-cta"
    >
      <a
        href={whatsappHref}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => {
          trackEvent("whatsapp_clicked", { location: "mobile_sticky_cta" });
        }}
        data-cta-label="Chat for instant quote"
        data-cta-location="sticky_bar"
        className="w-full inline-flex items-center justify-between gap-3 px-5 py-3.5 rounded-md bg-green-600 active:bg-green-700 text-white font-bold shadow-[0_6px_16px_-4px_rgba(22,163,74,0.45)]"
        data-testid="mobile-sticky-cta-button"
      >
        <span className="flex flex-col items-start leading-tight">
          <span className="text-[10px] uppercase tracking-[0.18em] text-green-100 font-bold">
            Starting at ₹2,499
          </span>
          <span className="inline-flex items-center gap-1.5 text-base">
            <MessageCircle className="h-4 w-4" />
            Chat for instant quote
          </span>
        </span>
        <ChevronRight className="h-5 w-5" />
      </a>
    </motion.div>
  );
};

export default CarServiceMobileStickyCTA;
